'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'circle-parking';
var width = 512;
var height = 512;
var aliases = ["parking-circle"];
var unicode = 'f615';
var svgPathData = 'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 32l80 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-80 0 0 128zm80 32l-80 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-152c0-13.3 10.7-24 24-24l88 0c53 0 96 43 96 96s-43 96-96 96z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleParking = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;